export default __webpack_public_path__ + "static/media/TRR-drink-americano.d10ce377.png";